import React, { useState } from "react";
import { currentSponsors, previousSponsors } from "../data/supportData";
import support from "../assets/Support.jpg";
import volunteers from "../assets/Volunteers.jpg";
import Work from "../assets/Work_With_Us.jpg";
import { Link } from "react-router-dom";
// import {
//   HandHeart,
//   Heart,
//   Briefcase,
//   Calendar,
//   DollarSign,
//   Building2,
//   ChevronRight,
//   Mail,
// } from "lucide-react";
// import Community from "./Community";



export default function SupportTWA() {
  const [sponsorModal, setSponsorModal] = useState(null);
  const [contactOpen, setContactOpen] = useState(false);
  const [contact, setContact] = useState({ name: "", email: "", message: "" });
  const [contactStatus, setContactStatus] = useState(null);


  // useEffect(() => {
  //   const t = setInterval(
  //     () => setTestIndex((i) => (i + 1) % testimonials.length),
  //     6000
  //   );
  //   return () => clearInterval(t);
  // }, []);

  function initials(text) {
    return text
      .split(" ")
      .slice(0, 2)
      .map((s) => s[0])
      .join("")
      .toUpperCase();
  }

  function handleContactSubmit(e) {
    e.preventDefault();
    if (!contact.name || !contact.email || !contact.message) {
      setContactStatus({ type: "error", text: "Please complete all fields." });
      return;
    }
    setContactStatus({ type: "sending", text: "Sending..." });
    setTimeout(() => {
      setContactStatus({
        type: "success",
        text: "Message sent! We’ll be in touch.",
      });
      setContact({ name: "", email: "", message: "" });
      setTimeout(() => setContactOpen(false), 1200);
    }, 900);
  }

  return (
<div className="font-['corporate-s'] min-h-screen">
  {/* HERO IMAGE SECTION */}
      <header className="relative">
        <img
          src={support}
          alt="Serve background"
          className="w-full h-64 sm:h-80 md:h-96 lg:h-[500px] object-cover"
        />
        <div className="absolute inset-0 bg-blue-900 opacity-60"> </div>
        <div className="absolute inset-0 flex items-center justify-center p-4">
          <h1 className="text-[2rem] sm:text-[3rem] md:text-[4.25rem] font-bold font-['corporate-s'] text-[#FFF] my-4 text-center">
            How to Support
          </h1>
        </div>
      </header>
        {/* OVERLAPPING CONTENT BOX */}
     <section className="relative bg-gray-200 py-16 h-[50px] md:h-[150px]">
    <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center px-6">
        <div className="bg-white relative p-6 md:px-6 md:w-[300px] shadow-xl mx-auto max-w-sm md:max-w-xl">
         <h2 className="text-md sm:text-xl md:text-2xl font-bold font-['corporate-s'] mb-4 text-[#003DA5] text-center">
              Your support helps break barriers, build brighter futures, 
              and create a more inclusive, equitable workforce.
            </h2>
          <p className="text-sm sm:text-md font-['corporate-s'] text-left">
              Whether you choose to volunteer your time and skills, 
              contribute through donations or sponsorships, or explore employment opportunities, 
              your involvement directly supports second chances and long-term success.
            </p>
          </div>
        </div>
      </section>


      {/* COLOR BLOCK SECTION */}
      {/* <section className="relative bg-gray-200 py-16 md:h-[150px]">
        <div className="absolute md:relative z-20 top-1/2 md:top-auto left-1/2 md:center-auto transform md:transform-none -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl px-6 md:px-40">
          <div className="bg-white p-6 md:p-10 shadow-xl">
            <h2 className="text-md sm:text-sm md:text-lg font-bold mb-4 text-[#003DA5] text-center">
              Your support helps break barriers, build brighter futures, and
              create a more inclusive, equitable workforce.
            </h2>
            <p className="text-sm md:text-md text-gray-700 font-['Crimson_Pro'] text-left">
              Whether you choose to volunteer your time and skills, contribute
              through donations or sponsorships, or explore employment
              opportunities, your involvement directly supports second chances
              and long-term success.
            </p>
          </div>
        </div>
      </section> */}

{/* NAV CARDS */}
      <section className="pt-40 pb-12">
        <div className="max-w-5xl h-55 mx-auto px-6 sm:px-10 md:px-16 lg:px-20 grid grid-cols-1 sm:grid-cols-3 gap-6">
          
          {[
            { title: "Volunteer", color: "#003DA5", id: "volunteer" },
            { title: "Ways to Give", color: "#FFC72C", id: "ways-to-give" },
            { title: "Work with Us", color: "#668ac9", id: "work-with-us" },
          ].map((item, i) => (
            <div
              key={i}
               className="bg-white p-6 flex flex-col justify-center md:items-left items-center shadow-lg/30 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 border-l-4 cursor-pointer"
            onClick={() => (window.location.href = `#${item.id}`)}
              style={{ borderColor: item.color }}
            >
              <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold font-['corporate-s']" style={{ color: item.color }}>
                {item.title}
              </h3>
            </div>
          ))}
        </div>
      </section>


{/* VOLUNTEER INTRO TEXT */}
<section id="volunteer" className="md:px-0 px-4">
           <div className="mx-auto max-w-7xl md:pr-20">
          <div className = "grid grid-cols-1 md:grid-cols-6 gap-3">
      <div className="text-left mt-20 md:col-start-2 md:col-span-5 flex flex-col sm:flex-row items-center py-3">
        <h2 className="text-5xl font-bold font-['corporate-s'] text-[#003DA5]">
          Volunteers
        </h2>
        <p className=" text-xl md:text-3xl leading-tight font-['farnham-display'] text-[#2b2b2b] md:pl-6 mt-2">
          Opportunities to dedicate time and service
        </p>
      </div>
      </div>
      </div>

{/* GRAY FEATURE SECTION */}
<div className="grid py-8 px-0 place-items-center bg-[#ffff]">
        <div className="flex flex-col md:flex-row items-center gap-6 bg-[#f0f0f0] md:h-[500px]">
        <div className="md:w-1/2 h-full relative">
           {/* Image container (on the right on large screens) */}
            <img
              src={volunteers} alt="Volunteers" className="w-full h-full object-cover" />
          </div>
    {/* Yellow Line + Text */}
    <div className="md:w-1/2 relative relative">
      <div className="pl-6 pt-10 pb-10">
        <p className="text-base md:text-xl lg:text-md xl:text-xl text-left my-4 px-2 font-['corporate-s'] border-l-6 border-[#FFD700] leading-relaxed">
        Volunteers throughout Missouri support TWA in multiple ways, including working 
        with individual jobseekers outside of job fair time to prepare and connect them with 
        employers. They also provide administrative support on projects such as tracking 
        recidivism, updating resource lists and doing research. In conversation with TWA 
        staff, volunteers apply their own gifts and talents in supportive ways. For example, 
        we are grateful to one of our ongoing volunteers whose passion is cycling who 
        connects our jobseekers with recycled bikes!
        </p>
        <div className="flex justify-end">
          <button
              onClick={() => setContactOpen(true)}
              className="relative w-50 h-16 md:mt-6 mr-10 bg-[#fff] font-['corporate-s'] text-[#1c398e] font-bold text-lg shadow-lg hover:text-[#003DA5]  transition border-2 border-[#003DA5]"
            >
              Volunteer with Us
            </button>
            </div>
      </div>
    </div>
  </div>
  </div>

{/* FINAL CTA BUTTONS */}
{/* FINAL CTA BUTTONS – Right-aligned on desktop, centered on mobile */}
<div className="py-8 bg-white">
  <div className="max-w-full mx-auto">
    <div className="md:col-span-3 gap-6 flex w-full flex-wrap justify-end mt-4 pr-8">
      
      {/* Volunteer Toolkit Button */}
      <a
         href="/Volunteer_Tool_Kit.zip" 
         download="volunteer-toolkit"
        className="flex w-50 h-16 text-center bg-[#003DA5] text-white font-bold font-['corporate-s'] justify-center px-6 py-2 items-center shadow-lg hover:bg-[#002B7F] transition-all transform hover:scale-105"
      >
        Volunteer Toolkit Download
      </a>

      {/* Events Button */}
      <Link
        to="/news#events"
        className= "flex w-50 h-16 text-center font-bold font-['corporate-s'] justify-center px-6 py-2 items-center shadow-lgtransition-all transform hover:scale-105 bg-white text-[#003DA5] border-2 border-[#003DA5]"
      >
        Events
      </Link>
    </div>
  </div>
</div>
</section>

<section id="ways-to-give" className="md:px-0 px-4">
  {/* Main Heading */}
           <div className="mx-auto max-w-7xl md:pr-20">
          <div className = "grid grid-cols-1 md:grid-cols-6 gap-3">
      <div className="md:col-start-2 col-span-2 my-10 flex justify-center md:justify-start">
        <h2 className="text-4xl sm:text-5xl font-bold text-[#FFC72C] font-['corporate-s'] text-center md:text-left tracking-tight">
          Ways to Give
        </h2>
      </div>
      </div>
      </div>

 {/* Sponsorships Section */}

<div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10 mb-6 items-center">
  <h2 className="md:col-span-1"></h2>
  <div className="space-y-6 md:col-span-3">
  <div className="flex flex-col md:flex-row gap-6">
    {/* Left Title Box */}
    <div className="bg-[#003DA5] flex items-center justify-center w-full md:w-[250px] h-[100px] md:h-auto">
      <h3 className="text-3xl font-bold text-white text-center">Sponsorships</h3>
    </div>

    {/* Content Box */}
    <div className="bg-[#f0f0f0] w-full md:flex-1 relative p-6 md:p-6">
      {/* Yellow Line */}
      <div className="md:pl-6">
        {/* Content */}
        <div className="text-base md:text-xl lg:text-md xl:text-xl text-left my-4 px-2 font-['corporate-s'] border-l-6 border-[#FFD700] leading-relaxed">
          <p>
            Sponsorships play a vital role in advancing the mission of SLU TWA. By becoming 
            a sponsor, your organization directly supports workforce development programs 
            that empower justice-involved individuals with the tools and opportunities they 
            need for long-term success. To learn more about sponsorship opportunities or to 
            discuss how your organization can get involved, please contact us.
          </p>
        </div>
      </div>
    </div>
  </div>

  {/* Sponsorships Button Row */}
  <div className="md:col-span-3 flex justify-end pr-8 mt-4">
    <button
      onClick={() => setContactOpen(true)}
      className="flex w-50 h-16 text-center font-bold font-['corporate-s'] justify-center px-6 py-2 items-center shadow-lgtransition-all transform hover:scale-105 bg-white text-[#003DA5] border-2 border-[#003DA5]"
    >
      Connect with Us
    </button>
  </div>

 {/* Donations Section */}


  <div className="flex flex-col md:flex-row gap-6">
    {/* Left Title Box */}
    <div className="bg-[#003DA5] flex items-center justify-center w-full md:w-[250px] h-[100px] md:h-auto">
      <h3 className="text-3xl md:px-12 font-bold text-white text-center">
        Donations
      </h3>
    </div>

    {/* Content Box */}
    <div className="bg-[#f0f0f0] w-full md:w-flex-1 relative p-6 md:p-6">
      {/* Yellow Line */}
      <div className="md:pl-6">
        {/* Content */}
        <div className="text-base md:text-xl lg:text-md xl:text-xl text-left my-4 px-2 font-['corporate-s'] border-l-6 border-[#FFD700] leading-relaxed">
          <p>
           Your donation to the Saint Louis University Transformative Workforce Academy 
           helps provide critical resources and support for justice-involved individuals working 
           to rebuild their lives. Contributions directly fund job training programs, mentorship, 
           career readiness services, and wraparound support that remove barriers to 
           success. Every gift—no matter the size—makes a lasting impact.
           Together, we can invest in second chances and stronger communities
          </p>
        </div>
      </div>
    </div>
  </div>

  {/* Donations Button Row */}
  <div className="md:col-span-3 gap-6 flex w-full flex-wrap justify-end mt-4 pr-8">
   <a
       href="https://engage.slu.edu/register/fund?sys:gift:fund=5f1377c9-952f-f0e2-4d65-15e8a9161ad6&sys:gift:notes=GIFT99W9"
      className="flex w-50 h-16 text-center bg-[#003DA5] text-white font-bold font-['corporate-s'] justify-center px-6 py-2 items-center shadow-lg hover:bg-[#002B7F] transition-all transform hover:scale-105"
    >
      Donate Now
    </a>
    <button
      onClick={() => setContactOpen(true)}
      className="flex w-50 h-16 text-center font-bold font-['corporate-s'] justify-center px-6 py-2 items-center shadow-lgtransition-all transform hover:scale-105 bg-white text-[#003DA5] border-2 border-[#003DA5]"
    >
      Connect with Us
    </button>
  </div>
  {/* CURRENT FUNDERS SECTION */}

  <div className="space-y-6 md:pr-40 col-span-1 justify-center md:col-span-3">
  {/* Heading aligned below Donations */}
  <h2 className="text-4xl font-bold font-['corporate-s'] text-[#305183] text-center md:text-left mb-8">
    Current Funders
  </h2>

  {/* Funders Boxes */}
            <div className="flex flex-col md:flex-row gap-6 justify-center md:justify-start items-center md:items-start">
              {currentSponsors.map((s, i) => (
                <button
                  key={i}
             //     onClick={() => setSponsorModal(s)}
                  aria-label={`Open sponsor ${s.name}`}
                  className="group justify-center flex w-60 h-30 items-center gap-1 px-4 py-4 bg-[#EFEFEF]"
                >
                  <div className="text-center">
                    <div className="font-semibold text-[#305183] ">
                      {s.name}
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>

          </div>
</div>

</section>



<section id="work-with-us" className="md:px-0 px-4 py-20">
  {/* Top Row: Heading + Paragraph */}
           <div className="mx-auto max-w-7xl md:pr-20">
          <div className = "grid grid-cols-1 md:grid-cols-6 gap-3">
      <div className="md:col-start-2 flex justify-center md:justify-start">
        <h2 className="text-4xl sm:text-5xl font-bold text-[#668ac9] font-['corporate-s'] text-center md:text-left tracking-tight">
          Work with Us
        </h2>
      </div>
      <div className="md:col-start-3 md:col-span-5">
        <p className="font-['farnham-display'] text-xl md:text-3xl leading-tight">
          SLU TWA is growing a mission-driven team dedicated to supporting 
          justice-involved individuals through workforce development, training, and long-term career success.
        </p>
      </div>
                  <div className="bg-[#EFEFEF] justify-center col-span-1 my-10 md:col-start-2 md:col-span-6 py-3">
              {/* Yellow Line */}
              <div className="border-l-6 border-[#FFC72C] ml-6 pl-4 md:pr-20">
                {/* Content */}
                <div className="font-['corporate-s'] text-base md:text-xl lg:text-lg xl:text-xl leading-relaxed text-[#2b2b2b]">
                  <p>
                    We are looking for passionate, skilled professionals who believe in second chances and inclusive employment. Lived 
                    experience with the justice system is welcomed and valued, but not required — we believe a diverse range of perspectives 
                    strengthens our impact. If you're interested in making a difference and being part of a supportive, purpose-driven 
                    environment, explore our current job openings or reach out to learn more
                  </p>
                </div>
              </div>
            </div>
            </div>
                      </div>
    <div className="grid py-8 px-0 place-items-center bg-[#ffff]">
        <div className="flex flex-col md:flex-row items-center gap-6 bg-[#003DA5]">
        <div className="md:w-1/2">
           {/* Image container (on the right on large screens) */}
            <img
              src={Work} alt="Work WIth us" className="w-auto h-auto" />
          </div>
    {/* Yellow Line + Text */}
    <div className="md:w-1/2 relative">
      <div className="md:col-span-2 p-8 md:p-12 text-white order-2 md:order-1">
        <p className="text-xl md:text-3xl font-['farnham-display'] leading-relaxed">
         Together, we can invest in second chances and stronger communities.
        </p>
      </div>
    </div>
  </div>
  </div>
  {/* FINAL CTA BUTTONS */}
<div className="py-3  text-center pb-2 bg-[#ffff]">
  <div className="flex flex-wrap gap-6 justify-end items-center pr-8"> 

        <button
          onClick={() => setContactOpen(true)}
          className="flex w-50 h-16 text-center bg-[#003DA5] text-white font-bold font-['corporate-s'] justify-center px-6 py-2 items-center shadow-lg hover:bg-[#002B7F] transition-all transform hover:scale-105"
        >
          Employee Opportunities
        </button>
        <button
          onClick={() => setContactOpen(true)}
          className="flex w-50 h-16 text-center font-bold font-['corporate-s'] justify-center px-6 py-2 items-center shadow-lgtransition-all transform hover:scale-105 bg-white text-[#003DA5] border-2 border-[#003DA5]"
        >
          Volunteer Mentor (part-time)
        </button>
  </div>
</div>

</section>






    {/*}  <Community /> */}
      {/* Sponsor Modal */}
      {sponsorModal && (
        <div
          aria-modal="true"
          role="dialog"
          className="fixed inset-0 z-50 flex items-center justify-center p-6"
        >
          <div
            className="fixed inset-0 bg-black/50"
            onClick={() => setSponsorModal(null)}
          />
          <div className="relative bg-white max-w-md w-full rounded-xl p-6 shadow-lg z-10">
            <button
              onClick={() => setSponsorModal(null)}
              className="absolute top-3 right-3 text-gray-500"
            >
              ✕
            </button>
            <h4 className="text-lg font-bold mb-2">{sponsorModal.name}</h4>
            <div className="text-sm text-gray-600 mb-4">
              {sponsorModal.type ? (
                <span className="inline-block mr-2 px-2 py-1 bg-emerald-50 rounded text-emerald-700 text-xs font-['corporate-s']">
                  {sponsorModal.type}
                </span>
              ) : null}
              Sponsor details and acknowledgement copy can go here. If you have
              a logo, swap the initials circle for an <code>&lt;img /&gt;</code>
              .
            </div>
            <div className="flex gap-3">
              <a
                href="https://engage.slu.edu/register/fund?sys:gift:fund=5f1377c9-952f-f0e2-4d65-15e8a9161ad6&sys:gift:notes=GIFT99W9"
                onClick={(e) => e.preventDefault()}
                className="px-4 py-2 bg-emerald-600 text-white rounded-lg"
              >
                Sponsor Info
              </a>
              <button
                onClick={() => {
                  setSponsorModal(null);
                  setContactOpen(true);
                }}
                className="px-4 py-2 border rounded-lg"
              >
                Contact
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Contact Modal */}
      {contactOpen && (
        <div
          aria-modal="true"
          role="dialog"
          className="fixed inset-0 z-50 flex items-center justify-center p-6"
        >
          <div
            className="fixed inset-0 bg-black/50"
            onClick={() => setContactOpen(false)}
          />
          <div className="relative bg-white max-w-lg w-full rounded-xl p-6 shadow-lg z-10 font-['corporate-s']">
            <button
              onClick={() => setContactOpen(false)}
              type="button"
              className="absolute top-3 right-3 text-gray-500"
            >
              ✕
            </button>
            <h3 className="text-xl font-semibold mb-2 text-[#00244D] font-['corporate-s']">Contact SLU TWA</h3>
            <p className="text-sm text-gray-600 mb-4">
              For sponsorships, volunteering, or hiring questions — send us a
              message.
            </p>

            <label className="block text-sm text-gray-700 mb-1">Name</label>
            <input
              value={contact.name}
              onChange={(e) =>
                setContact((c) => ({ ...c, name: e.target.value }))
              }
              className="w-full mb-3 px-3 py-2 border rounded"
              required
            />

            <label className="block text-sm text-gray-700 mb-1">Email</label>
            <input
              type="email"
              value={contact.email}
              onChange={(e) =>
                setContact((c) => ({ ...c, email: e.target.value }))
              }
              className="w-full mb-3 px-3 py-2 border rounded"
              required
            />

            <label className="block text-sm text-gray-700 mb-1">Message</label>
            <textarea
              value={contact.message}
              onChange={(e) =>
                setContact((c) => ({ ...c, message: e.target.value }))
              }
              rows="4"
              className="w-full mb-4 px-3 py-2 border rounded"
              required
            />

            <div className="flex items-center gap-3">
              <button
                onClick={handleContactSubmit}
                className="px-4 py-2 bg-[#00244D] text-white rounded-lg"
              >
                Send message
              </button>
              <a
                className="px-4 py-2 border rounded-lg"
                href={`mailto:meredith.rj@slu.edu?subject=SLU%20TWA%20Contact&body=${encodeURIComponent(
                  contact.message || ""
                )}`}
              >
                Or open mail
              </a>
            </div>

            {contactStatus && (
              <div
                className={`mt-4 text-sm ${
                  contactStatus.type === "error"
                    ? "text-rose-600"
                    : "text-green-700"
                }`}
              >
                {contactStatus.text}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
